import React, { Component } from 'react';
import GallerySideInfo from './gallerySideInfo';
import Paragraph from './paragraph';
import Crossfade from './crossfade';
import ArtistTileImg from './artistTileImg';
import { SRLWrapper } from 'simple-react-lightbox';

class GalleryAbout extends Component {
  render() {
    const { galleryData } = this.props;

    // Crossfade images for fall opening reception
    const crossfadeImages = [
      {
        src: 'https://tahoeartleague.org/uploads/crossfades/fall-show-opening-23/opening-1.jpg',
        alt: 'lady holding a painting',
      },
      {
        src: 'https://tahoeartleague.org/uploads/crossfades/fall-show-opening-23/opening-2.jpg',
        alt: 'girl sitting infront of painting',
      },
      {
        src: 'https://tahoeartleague.org/uploads/crossfades/fall-show-opening-23/opening-3.jpg',
        alt: 'two people holding a painting',
      },
      {
        src: 'https://tahoeartleague.org/uploads/crossfades/fall-show-opening-23/opening-4.jpg',
        alt: 'two people holding a painting',
      },
      {
        src: 'https://tahoeartleague.org/uploads/crossfades/fall-show-opening-23/opening-5.jpg',
        alt: 'two people holding a painting',
      },
      {
        src: 'https://tahoeartleague.org/uploads/crossfades/fall-show-opening-23/opening-6.jpg',
        alt: 'lady holding a painting',
      },
      {
        src: 'https://tahoeartleague.org/uploads/crossfades/fall-show-opening-23/opening-7.jpg',
        alt: 'two people holding a pointing',
      },
    ];

const eventImgs = [
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-1.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-2.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-3.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-4.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-5.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-6.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-7.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-8.JPG" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-9.jpg" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-10.jpeg" },
  { src: "https://talart.org/uploads/gallery/passportdrawing/passport-drawing-2026-11.jpeg" },

];


    return (
      <div className="bottomMargin-container">
        <h2>{galleryData.heading}</h2>
        <div className="aboutCart-row">
          <div className="aboutCart-p">
            {' '}
            {/* Was <p> before. */}
            {galleryData.paragraph && (
              <Paragraph text={galleryData.paragraph} />
            )}
            {/* 2026 Show Schedule Section. */}
            <section
              style={{ marginTop: '3rem', marginBottom: '3rem' }}
              id="show-application"
            >
              <p>To show and sell your work in our Gallery please contact one of our Gallery Team:</p>
              <p>
                Kathy Dewey – <a href="mailto:yourejustducky@gmail.com">yourejustducky@gmail.com</a><br />
                Claudia Elkin – <a href="mailto:friendlyart@icloud.com">friendlyart@icloud.com</a><br />
                Diane Fannan – <a href="mailto:dfannan@gmail.com">dfannan@gmail.com</a><br />
                Tamara Richey – <a href="mailto:support4soul@gmail.com">support4soul@gmail.com</a>
              </p>
              <p>
                Fall Show Aug.28-Nov.28, 2026 Opening Reception Aug. 28th at 5:30<br />
                Winter Show Dec. 3, 2026 - Feb. 28, 2027  Opening Reception Dec. 3rd at 5:30<br />
                Spring Show March 4 - May 30, 2027  Opening Reception March 4th at 5:30<br />
                Summer Show June 3 - Aug. 29, 2027  Opening Reception June 3rd at 5:30<br />
                Fall Show Sept. 2 - Nov. 28, 2027  Opening Reception Sept. 2nd at 5:30<br />
                Winter Show Opens Dec. 2nd at 5:30<br />
              </p>
            </section>
          </div>
          <GallerySideInfo galleryData={galleryData} />
        </div>
          {/* Passport drawing event */}
          <h3 id="passportdrawing">Studio Tour Passport Drawing 2026</h3>
          <p className="aboutCart-p">Photos from Studio Tour 2026 and the Passport Winners!</p>
          <SRLWrapper>
            <div className="artists-gridSixCol" style={{paddingTop: 0}}>
              {eventImgs.map((image) => (
                <ArtistTileImg image={image} key={image._id} />
              ))}
              {/* {images.map((image) => (
                <ArtistTileImg image={image} key={image._id} />
              ))} */}
            </div>
          </SRLWrapper>
      </div>
    );
  }
}

export default GalleryAbout;
